/**
 * 联系方式 7 天自动轮换 —— 前端入口
 *
 * 纯逻辑请改 utils/contactRotation.shared.ts。
 * 本文件只额外提供 React Hook，并 re-export 所有共享成员，
 * 让现有前端调用方无需改动 import 路径。
 */

import { useEffect, useState } from 'react';
import {
  getCurrentEmail,
  getCurrentPhone,
  msUntilNextRotation,
} from './contactRotation.shared';

export {
  CONTACT_EMAILS,
  CONTACT_PHONES,
  BASE_DATE_UTC,
  ROTATION_DAYS,
  ROTATION_MS,
  getRotationPeriod,
  getCurrentEmail,
  getCurrentPhone,
  msUntilNextRotation,
} from './contactRotation.shared';

/**
 * React Hook：自动在下一个轮换时间点刷新组件，
 * 确保长时间停留的页面也能跟随切换。
 */
export function useRotatedContact(): { email: string; phone: string } {
  const [value, setValue] = useState(() => ({
    email: getCurrentEmail(),
    phone: getCurrentPhone(),
  }));

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;

    const schedule = () => {
      // 加 1 秒缓冲，避免边界时刻误差。
      const delay = msUntilNextRotation() + 1000;
      timer = setTimeout(() => {
        setValue({ email: getCurrentEmail(), phone: getCurrentPhone() });
        schedule();
      }, delay);
    };

    schedule();
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, []);

  return value;
}
